import React from 'react';
import Checkbox from '@material-ui/core/Checkbox';
import MenuItem from '@material-ui/core/MenuItem';
import PropTypes from 'prop-types';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Select from '../select';
import styles from './checkbox-dropdown.module.scss';

const noop = () => {};

// A lot of this was cribbed from the Menu Composition example in the material-ui docs https://material-ui.com/components/menus/#menulist-composition
const CheckboxDropdown = ({
    checkboxes,
    handleChange,
    values,
    buttonLabel
}) => (
    <Select onChange={noop} type="text" value={buttonLabel}>
        <MenuItem key={buttonLabel} value={buttonLabel}>
            {buttonLabel}
        </MenuItem>
        {checkboxes.map(({ label, value }) => (
            <MenuItem key={value}>
                <FormControlLabel
                    control={
                        <Checkbox
                            className={styles.checkboxRoot}
                            name="status"
                            value={value}
                            checked={values.includes(value)}
                            onChange={handleChange}
                        />
                    }
                    label={label}
                />
            </MenuItem>
        ))}
    </Select>
);

CheckboxDropdown.propTypes = {
    checkboxes: PropTypes.arrayOf(
        PropTypes.shape({
            value: PropTypes.string.isRequired,
            label: PropTypes.string.isRequired
        })
    ).isRequired,
    handleChange: PropTypes.func.isRequired,
    values: PropTypes.arrayOf(PropTypes.string).isRequired,
    buttonLabel: PropTypes.string.isRequired
};

export default CheckboxDropdown;
